import { useEffect } from "react";

export const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="terms-of-service-page">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-4">
              Legal
            </p>
            <h1 className="text-3xl md:text-5xl tracking-[0.02em] text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Terms of Service
            </h1>
            <p className="text-white/40 text-sm">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8 text-white/70 font-light leading-relaxed">
              
              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>1. Agreement to Terms</h2>
                <p>
                  By accessing or using the Goldnote Corporation website and purchasing our products, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>2. Products and Services</h2>
                <p className="mb-4">
                  Goldnote Corporation offers precious metal products, including Goldnotes containing fine gold. All products are:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Protected by U.S. Patent No. 10,668,765</li>
                  <li>Authenticated via QR code technology</li>
                  <li>Self-authenticating via patented QR technology</li>
                  <li>Subject to availability and pricing changes</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>3. Pricing and Payment</h2>
                <p>
                  All prices are displayed in USD unless otherwise specified. Prices for precious metal products may fluctuate based on market conditions. Payment must be received in full before shipment. We accept major credit cards and other payment methods as displayed at checkout.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>4. Shipping and Delivery</h2>
                <p>
                  We ship to addresses within our supported regions. Shipping times vary based on destination and shipping method selected. Risk of loss and title pass to you upon delivery to the carrier. We are not responsible for delays caused by customs, weather, or other factors beyond our control.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>5. Returns and Refunds</h2>
                <p className="mb-4">
                  Due to the nature of precious metal products:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Returns are accepted within 14 days of delivery for unopened, undamaged products</li>
                  <li>Products must be returned in original packaging</li>
                  <li>Refunds will be processed based on the current market value at time of return</li>
                  <li>Shipping costs are non-refundable</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>6. Intellectual Property</h2>
                <p>
                  All content on this website, including text, graphics, logos, images, and software, is the property of Goldnote Corporation and is protected by intellectual property laws. Our products are protected by U.S. Patent No. 10,668,765. Unauthorized use is prohibited.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>7. Limitation of Liability</h2>
                <p>
                  Goldnote Corporation shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or products. Our total liability shall not exceed the amount paid for the specific product giving rise to the claim.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>8. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws of the United States. Any disputes shall be resolved in the appropriate courts of jurisdiction.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>9. Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of any modifications.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>10. Contact Information</h2>
                <p>
                  For questions regarding these Terms of Service, please contact us at:
                </p>
                <p className="mt-4">
                  <strong className="text-[#D4AF37]">Goldnote Corporation</strong><br />
                  Email: legal@goldnote.com<br />
                  Phone: 1-800-GOLDNOTE
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
